module.exports = __webpack_public_path__ + "img/cxTrends-mini-3.a917989a.png";